import { Modal, ModalFooterAction } from "components/primitives/Modal";
import { DashboardContext } from "contexts/DashboardContext";
import { ModalsContext } from "contexts/ModalsContext";
import React, { useContext, useState } from "react";
import { Form } from "react-bootstrap";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";

import { MODAL_SAVE_WORD_LIST } from "./constatnts";
import { ModalSaveHeader } from "./ModalHeaders";

interface ModalSaveNameProps {
  words: string;
}

export const ModalSaveName = ({ words }: ModalSaveNameProps) => {
  const modalsContext = useContext(ModalsContext);
  const { data, setData: setGlobalData } = useContext(DashboardContext);

  const [name, setName] = useState("");
  const [hasLimit, setHasLimit] = useState(false);
  const [formError, setFormError] = useState("");

  const handleChangeName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);

    if (event.target.value.length === 20) {
      setHasLimit(true);
    } else if (hasLimit && event.target.value.length < 20) {
      setHasLimit(false);
    }
  };

  const handleSave = () => {
    const duplicate = data.saveWords.find((w) => w.name === name);

    if (duplicate) {
      setFormError(`This name already exists`);

      return;
    }

    const newSavedWords = [{ id: uuidv4(), name, words }].concat(data.saveWords || []);
    setGlobalData({ saveWords: newSavedWords });

    modalsContext.closeModal();
    setName("");
  };

  const handleClose = () => {
    modalsContext.closeModal();
    setName("");

    if (formError) {
      setFormError("");
    }
  };

  const footerActions: ModalFooterAction[] = [
    {
      key: "cancel",
      textBtn: "Cancel",
      color: "var(--danger)",
      action: handleClose,
    },
    {
      key: "save",
      textBtn: "Save Word List",
      color: "var(--primary)",
      action: handleSave,
      disabled: !name,
    },
  ];

  return (
    <div>
      <Modal
        isOpen={modalsContext.modalData.name === MODAL_SAVE_WORD_LIST}
        header={ModalSaveHeader}
        footerActions={footerActions}
      >
        <Form.Group>
          <Label>
            Name
            <small
              style={{
                color: hasLimit ? "var(--orange)" : "inherit",
              }}
            >
              (Max characters: 20)
            </small>
          </Label>

          <Form.Control type="text" maxLength={20} value={name} onChange={handleChangeName} />

          <ErrorMessage>{formError}</ErrorMessage>
        </Form.Group>
      </Modal>
    </div>
  );
};

const Label = styled(Form.Label)`
  small {
    margin-left: 5px;
  }
`;

const ErrorMessage = styled("span")`
  color: var(--danger);
`;
